import { api } from "@/api";

/* ==========================
   Get Language
========================== */
export async function getUserLanguage(upn: string): Promise<any> {
  const res = await api.language(upn);
  return res;
}

/* ==========================
   Save Language
========================== */
export async function saveUserLanguage(payload: any): Promise<any> {
  const res = await api.saveLanguage(payload);
  return res;
}
